import pathUtils from '../util/pathUtils'
import routeUtils from '../util/routeUtils'

export default {
  computed: {
    topRoute: function () {
      let viewDepth = routeUtils.getInstanceMatchIndex(this)
      return viewDepth === 1
    },
    topComponent: function () {
      let viewDepth = routeUtils.getRouteMatchIndex(this)
      return viewDepth === 1
    }
  },
  methods: {
    getContextPath: function (path) {
      return pathUtils.getContextPath(path)
    },
    getHomePath: function () {
      return pathUtils.getHomePath()
    }
  },
  filters: {
    formatFileSize: function (size) {
      if (size < 1024) {
        return `${size}B`
      } else if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(1).replace(/\.?0+$/, '')}KB`
      } else if (size < 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(1).replace(/\.?0+$/, '')}MB`
      } else {
        return `${(size / 1024 / 1024 / 1024).toFixed(1).replace(/\.?0+$/, '')}GB`
      }
    }
  }
}
